import { AxiosResponse } from 'axios';
import { clientProvider } from '@/api/clients/axios';
import {
  CustLstByUserNameAndPhoneNumberRequestDTO,
  CustLstByUserNumKeyRequestDTO,
} from '@/api/dto/request/CustLstRequestDTO';
import NoticeRequestDTO from '@/api/dto/request/NoticeRequestDTO';
import CustLstResponseDTO from '@/api/dto/response/CustLstResponseDTO';
import NoticeResponseDTO from '@/api/dto/response/NoticeResponseDTO';
import Repository from './repository';

class BillRepository extends Repository {
  async NP_NOTICE(
    citygasCode: string,
    noticeDTO: NoticeRequestDTO,
  ): Promise<AxiosResponse<NoticeResponseDTO>> {
    return await this.post(citygasCode, '/naver/np_notice', noticeDTO);
  }

  async NP_CUST_LST(
    citygasCode: string,
    custLstDTO: CustLstByUserNumKeyRequestDTO | CustLstByUserNameAndPhoneNumberRequestDTO,
  ): Promise<AxiosResponse<CustLstResponseDTO>> {
    return await this.post(citygasCode, '/naver/np_cust_lst', custLstDTO);
  }
}

export const billRepository = new BillRepository(clientProvider.getClient());
